module.exports = "<p>\r\n  speedruns works!\r\n</p>\r\n"